export function getChatHistoryPath(projectId: string): string {
  return `/media/projects/${projectId}/chat-history`;
}

export function getProjectAnalyticsPath(projectId: string): string {
  return `/media/projects/${projectId}/analytics`;
}

export function getProjectAddonsAnalyticsPath(projectId: string): string {
  return `/media/projects/${projectId}/analytics/addons`;
}
